import { stateReducerFactory } from 'core/generic';
import { Action } from 'core/generic';
import React from 'react';
import { CreateCategory, fetchCategories, ListCategories } from './';
import { SearchCategorie } from './SearchCategorie';
import {
  BEFORE_PROCESSING,
  Categorie,
  ERROR_FETCH_CATEGORIES,
  ON_FETCH_CATEGORIES,
  ON_UPDATE_CATEGORIE,
} from './types';

interface State {
  list: Categorie[];
  filteredList: Categorie[];
  total: number;
  isLoading: boolean;
}

const initialState: State = {
  list: [],
  filteredList: [],
  total: 0,
  isLoading: false,
};

const reducer = stateReducerFactory({
  initialState,
  onPut: ON_UPDATE_CATEGORIE,
  onFetch: ON_FETCH_CATEGORIES,
  beforeProcessing: BEFORE_PROCESSING,
  onError: ERROR_FETCH_CATEGORIES,
});

export class ArtistCategories extends React.Component {
  state: State = initialState;

  async componentDidMount() {
    await fetchCategories(this.dispatch);
    this.setState({
      filteredList: this.state.list,
    });
  }

  dispatch = (action: Action) => {
    this.setState(() => reducer(this.state, action));
  };

  filterCategories = (key: string) => {
    const { list } = this.state;
    if (key === '') {
      return this.setState({
        filteredList: list,
      });
    }

    const filteredList: Categorie[] = list.filter((categorie) =>
      categorie.description.toLowerCase().includes(key.toLowerCase()),
    );

    this.setState({ filteredList });
  };

  render() {
    const { isLoading, filteredList } = this.state;

    return (
      <div>
        <SearchCategorie filterCategories={this.filterCategories} />
        <div className='ui segment'>
          <CreateCategory
            list={this.state.filteredList}
            dispatch={this.dispatch}
          />
        </div>
        <ListCategories
          list={filteredList}
          isLoading={isLoading}
          dispatch={this.dispatch}
        />
      </div>
    );
  }
}
